
import React, { useRef, useState, useEffect } from 'react'

import styles from './toggle_sections.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Media from './basic/media'
import Button from './basic/button'
import Accordion from './accordion'
import classNames from 'classnames'
import config from '../config'

function ToggleSections(props) {
	const container = useRef(null)
	const contentHeights = useRef([])
	const fields = props.fields
	let [activeSection, setActiveSection] = useState(0)
	const [contentHeight, setContentHeight] = useState(0)
	const [containerPosition, setContainerPosition] = useState(0)
	const [loaded, setLoaded] = useState(false)
	const [isMobile, setIsMobile] = useState(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < config.mobileWidth)

	function animateToggle(active){
		let sectionsWrapper = document.querySelector('.' + styles.sections_wrapper)
		let activeToggle = document.querySelector('.' + styles.active_toggle)
		let toggles = document.querySelectorAll('.' + styles.toggle)
		let activeToggleWidth = toggles[active].clientWidth
		let activeToggleLeft = toggles[active].offsetLeft
		
		sectionsWrapper.style.minHeight = contentHeights.current[active]/2 + 'px'
		activeToggle.style.width = activeToggleWidth + 'px'
		activeToggle.style.transform = 'translateX(' + activeToggleLeft + 'px)'
	}

	//handle toggle click
	const handleClick = (e) => {
		let index = Array.from(e.target.parentNode.children).indexOf(e.target) - 1
		let scrollPos = document.querySelector('.' + styles.toggle_sections).getBoundingClientRect().top + window.scrollY + (contentHeights.current[index-1] ? contentHeights.current[index-1] : 0) - 150

		if(isMobile){
			scrollPos = scrollPos + (index * 80) + 50
		}

		window.scrollTo({top: scrollPos, behavior: 'smooth'})
	}

	useEffect(() => {
		animateToggle(0)

		const onPageLoad = () => {
			setLoaded(true)
		}

		if (document.readyState === 'complete') {
			onPageLoad()
		} else {
			window.addEventListener('load', onPageLoad, false)
			return () => window.removeEventListener('load', onPageLoad)
		}
	}, [])

	useEffect(() => {
		const resizeHandler = () => {
			let containerHeight = 0

			if(fields.sections){
				fields.sections.forEach((section, index) => {
					let sectionElement = document.querySelectorAll('.' + styles.section_wrapper)[index]
					let sectionHeight = sectionElement.clientHeight

					if(!isMobile){
						sectionHeight = sectionHeight * 2
					}

					contentHeights.current[index] = sectionHeight
					containerHeight += sectionHeight
				})
			}

			setContentHeight(containerHeight)
			setIsMobile(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < config.mobileWidth)
		}
		//set containerPosition to the top of the container in context of the document
		if(container.current){
			let containerPosition = container.current.getBoundingClientRect().top
			let scrollTop = window.scrollY
			
			setContainerPosition(containerPosition + scrollTop)
		}

		window.addEventListener('resize', resizeHandler)

		const changeHandler = (element) => {
			let currentHeight = element.clientHeight
			let index = Array.from(element.parentNode.children).indexOf(element)
			let originalHeight = contentHeights.current[index]/2

			if(isMobile){
				originalHeight = contentHeights.current[index]
			}

			//add the difference to the wrapper margin to keep content from overlapping
			let wrapper = document.querySelector('.' + styles.toggle_sections_outer)
			let margin = currentHeight - originalHeight

			if(!isMobile)
				wrapper.style.marginBottom = margin + 'px'
		}

		if(container.current){
			//observer for height changes on the sections
			const observer = new ResizeObserver(entries => {
				for (let entry of entries) {
					changeHandler(entry.target)
				}
			})

			let observerTargets = document.querySelectorAll('.' + styles.section_wrapper)
			observerTargets.forEach(element => observer.observe(element))
		}

		resizeHandler()

		return () => {
			window.removeEventListener('resize', resizeHandler)
		}
	}, [loaded, isMobile])


	useEffect(() => {
		const handleScroll = () => {
			let scroll = window.scrollY
			let active = 0

			contentHeights.current.forEach((height, index) => {
				let currentHeight = contentHeights.current[index] || 0

				if(isMobile){
					if(scroll - (window.innerHeight) > currentHeight){
						active = index
					}
				} else {
					if(scroll + (window.innerHeight / 2) > currentHeight*2){
						active = index
					}
				}
			})

			setActiveSection(active)
			animateToggle(active)
		}

		
		handleScroll()

		window.addEventListener('scroll', handleScroll)

		return () => {
			window.removeEventListener('scroll', handleScroll
		)}
	}
	, [contentHeights, containerPosition])


	return <BlockWrapper {...props} className={styles.toggle_sections}>
		<ScrollAnimation styles={styles}>
			<div className={styles.toggle_sections_outer} style={{ minHeight: `${contentHeight}px` }}>
			<div ref={container} className={styles.toggle_sections_inner}>

				<div className={styles.toggle_wrapper}>
					<span className={styles.active_toggle}></span>
					{fields.sections && fields.sections.map((section, index) => {
						return <div key={index} className={classNames(styles.toggle, activeSection == index ? styles.active : null)} 
						onClick={(e) => {handleClick(e)}}
						>
							{section.toggle_title}
						</div>
					}
					)}
				</div>
				
				<div className={styles.sections_wrapper}>
					{fields.sections && fields.sections.map((section, index) => {
						return <div key={index} className={classNames(styles.section_wrapper, activeSection == index ? styles.active : null)} >
							<div className={styles.intro} dangerouslySetInnerHTML={{__html: section.intro_content}}></div>
							
							<div className={styles.flex_wrapper}>
								<div>
									<div className={styles.content_wrapper}>
										<div className={styles.content} dangerouslySetInnerHTML={{__html: section.content}}></div>
										{section.accordion.items && <Accordion fields={{...section.accordion}} theme='theme_2' />}
									</div>

									{section.buttons && section.buttons.map((button, index) => {
										return <Button key={index} fields={{...button}} />
									})}
								</div>

								<div className={styles.media_wrapper}>
									<Media {...section.media} settings={{autoplay: (activeSection == index ? true : false), loop: true}} />
								</div>
							</div>
							
						</div>
					})}
				</div>

			</div>
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default ToggleSections